import React from "react";
import Helmet from "react-helmet";
import { SEO } from "@fishrmn/fishrmn-components";
import { socialMediaTypes } from "@fishrmn/fishrmn-types";

import "../../semantic/dist/semantic.min.css";
import "../css/pages.scss";
import config from "../../config/config";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const getPageMetadata = path =>
  path === "/"
    ? config.baseConfig.pageMetadata.home
    : config.baseConfig.pageMetadata[path.split("/").join("")];

export default class DefaultLayout extends React.Component {
  componentWillMount() {
    if (typeof window !== `undefined`) {
      function Deferred() {
        const self = this;
        this.promise = new Promise((resolve, reject) => {
          self.reject = reject;
          self.resolve = resolve;
        });
      }
      window.fbLoaded = new Deferred();

      window.fbAsyncInit = function() {
        FB.init({
          appId: process.env.APP_ID,
          cookie: true,
          xfbml: true,
          version: "v3.0"
        });
        window.fbLoaded.resolve();
      };

      (function(d, s, id) {
        let js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    this.pageMetadata = getPageMetadata(this.props.location.pathname);
  }

  render() {
    const { children, location } = this.props;
    const pageMetadata = this.pageMetadata || {}; // Default to empty object
    return (
      <div>
        <Helmet>
          <meta
            name="google-site-verification"
            content="bEtOwknqbQ_lvYVqMtDQbaTFPvW6v4kQpP849L9hX-Y"
          />
          <meta
            name="facebook-domain-verification"
            content="gwx7uzl0sx2kageugeeetmc06xxb4o"
          />
          <script async src="//static.getclicky.com/101361093.js"></script>
          <meta
            name="msvalidate.01"
            content="8455E6209E687C93C1D0A3C483E5A039"
          />
          <script type="text/javascript">
            {" var _d_site = _d_site || 'E2DC9E8F674D8F336292A0FF'; "}
          </script>
          <script src="https://widget.privy.com/assets/widget.js" />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Restaurant",
              name: "Whole Sol Blend Bar",
              url: "https://wholesol.com/",
              description:
                "100% USDA Certified Organic Acai & Smoothie Bowls & Cold-Pressed Juice | Breakfast & Lunch Superfood Bliss | Gluten-Free | Dairy-Free.  Best New Restaurant, Best Brunch, Best Vegan/Vegetarian - 5280 Magazine",
              menu: "https://wholesol.com/ourmenu/",
              servesCuisine: [
                "Health Food",
                "Organic Food",
                "Juices & Smoothies"
              ],
              priceRange: "$$",
              openingHours: "Mon-Fri 6am-7pm, Sat-Sun 7am–5pm",
              image:
                "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg",
              telephone: "7203727862",
              email: "HI@WHOLESOL.COM",
              slogan: "Life is Short. Lick the Bowl.",
              sameAs: [
                "https://www.facebook.com/WholeSolBlendBar/",
                "https://www.instagram.com/whole_sol/"
              ],
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://wholesol.com/#webpage",
                name: "Whole Sol Blend Bar",
                url: "https://wholesol.com/",
                aggregateRating: {
                  itemReviewed: {
                    "@type": "LocalBusiness",
                    name: "Whole Sol Blend Bar",
                    priceRange: "$$",
                    telephone: "7203727862",
                    image:
                      "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg",
                    address: {
                      addressRegion: "CO"
                    }
                  },
                  ratingValue: "5",
                  ratingCount: "5",
                  reviewCount: "12"
                },
                reviews: [
                  {
                    "@type": "Review",
                    name:
                      "Whole Sol Blend Bar Adds Two New Locations to Superfood Empire",
                    reviewBody:
                      "Chock-full of smoothie bowls, toasts, and snacks sporting ingredients we could all probably stand to eat more of, like dragon fruit, açaí, chia, and kale ... Pick up the brand's 100-percent organic and dairy- and gluten-free superfood... at chic storefronts in RiNo and at Boulder's 29th Street Mall.",
                    author: {
                      "@type": "Person",
                      name: "5280"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "Whole Sol Opens Flagship Location at Sloan's Lake",
                    reviewBody:
                      "Everything on Whole Sol's menu is organic, gluten-free and dairy-free and all items can be made vegan upon request - if they aren't already. Whole Sol's signature smoothie bowls have no added sugar, fruit juice, sweeteners or preservatives of any kind and average under 400 calories per bowl. The açaí is 100% pure and wild-harvested and blended with organic fruit to create a nutty, slightly sweet flavor that tastes amazing when topped with Purely Elizabeth granola and fresh fruit",
                    author: {
                      "@type": "Person",
                      name: "303 Magazine"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "Juice bar Whole Sol opens second Boulder location",
                    reviewBody:
                      "Purposely designed to be COVID-conscious, encourage healthy and safe habits and reassure guests.",
                    author: {
                      "@type": "Person",
                      name: "Boulder Daily Camera"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "Perfect Way To Kick-start Your Morning",
                    reviewBody:
                      "Taking smoothie bowls to the next-level.. the perfect way to kick-start your morning, wrap up a solid workout, or shake off an afternoon energy crash. Whole Sol brings health nuts a boost of energy that is equal parts healthy and delicious.",
                    author: {
                      "@type": "Person",
                      name: "DiningOut"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "Healthy and Energizing Cuisine",
                    reviewBody:
                      "healthy and energizing cuisine designed as much to invigorate as to delight... head here to stock up on toast and healthy bowls galore.",
                    author: {
                      "@type": "Person",
                      name: "303 Magazine"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "All Organic",
                    reviewBody:
                      "A nutritious menu fit for athletes.. all organic and gluten- and dairy-free. Top 10 Toasts to Try in Denver",
                    author: {
                      "@type": "Person",
                      name: "Eater"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "OUT OF THIS WORLD",
                    reviewBody:
                      "the queen of smoothie bowls - OUT OF THIS WORLD... 10/10 delicious and will definitely be my new go to place in the Denver area",
                    author: {
                      "@type": "Person",
                      name: "@liftingspoons"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "The MOST Delicious Smoothie bowls",
                    reviewBody:
                      "The MOST delicious smoothie bowls... Phil & Alexa are changing the game with no refined sugars, plenty of local ingredients, and an obvious homemade touch.",
                    author: {
                      "@type": "Person",
                      name: "@whatcaitate"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "ORGANIC and Super Healthy",
                    reviewBody:
                      "My new go-to for ORGANIC and super healthy bowls, juices, avo toasts, salads.",
                    author: {
                      "@type": "Person",
                      name: "@wholenikolenutrition"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  },
                  {
                    "@type": "Review",
                    name: "Hype",
                    reviewBody: "The hype is REAL.",
                    author: {
                      "@type": "Person",
                      name: "@raeehly"
                    },
                    itemReviewed: {
                      "@type": "LocalBusiness",
                      name: "Whole Sol Blend Bar",
                      priceRange: "$$",
                      address: {
                        "@type": "PostalAddress",
                        addressRegion: "CO"
                      },
                      telephone: "(720) 372-7862",
                      image: {
                        "@type": "ImageObject",
                        url:
                          "https://wholesol.com/static/whole-sol-place-setting.7870e818.jpg"
                      }
                    }
                  }
                ]
              },
              Address: {
                "@type": "PostalAddress",
                addressRegion: "CO"
              },
              location: [
                {
                  "@type": "PostalAddress",
                  addressCountry: "United States",
                  addressLocality: "Denver",
                  addressRegion: "CO",
                  postalCode: "80202",
                  streetAddress: "1735 Chestnut Place",
                  areaServed: {
                    "@type": "Place",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "39.755360",
                      longitude: "-105.001860"
                    }
                  },
                  mainEntityOfPage: "https://wholesol.com",
                  name: "Whole Sol Blend Bar",
                  telephone: "(720) 372-7862",
                  email: "HI@WHOLESOL.COM"
                },
                {
                  "@type": "PostalAddress",
                  addressCountry: "United States",
                  addressLocality: "Boulder",
                  addressRegion: "CO",
                  postalCode: "80302",
                  streetAddress: "1420 Pearl St",
                  areaServed: {
                    "@type": "Place",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "40.018390",
                      longitude: "-105.276700"
                    }
                  },
                  mainEntityOfPage: "https://wholesol.com",
                  name: "Whole Sol Blend Bar",
                  telephone: "(720) 475-1355",
                  email: "HI@WHOLESOL.COM"
                },
                {
                  "@type": "PostalAddress",
                  addressCountry: "United States",
                  addressLocality: "Denver",
                  addressRegion: "CO",
                  postalCode: "80205",
                  streetAddress: "3605 Walnut St",
                  areaServed: {
                    "@type": "Place",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "39.769080",
                      longitude: "-104.973720"
                    }
                  },
                  mainEntityOfPage: "https://wholesol.com",
                  name: "Whole Sol Blend Bar",
                  telephone: "(303) 856-7717",
                  email: "HI@WHOLESOL.COM"
                },
                {
                  "@type": "PostalAddress",
                  addressCountry: "United States",
                  addressLocality: "Denver",
                  addressRegion: "CO",
                  postalCode: "80204",
                  streetAddress: "1611 Raleigh St",
                  areaServed: {
                    "@type": "Place",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "39.743000",
                      longitude: "-105.041908"
                    }
                  },
                  mainEntityOfPage: "https://wholesol.com",
                  name: "Whole Sol Blend Bar",
                  telephone: "(720) 328-9769",
                  email: "HI@WHOLESOL.COM"
                },
                {
                  "@type": "PostalAddress",
                  addressCountry: "United States",
                  addressLocality: "Boulder",
                  addressRegion: "CO",
                  postalCode: "80301",
                  streetAddress: "1810 29th St #1087",
                  areaServed: {
                    "@type": "Place",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "40.0184716",
                      longitude: "-105.2554917"
                    }
                  },
                  mainEntityOfPage: "https://wholesol.com",
                  name: "Whole Sol Blend Bar",
                  telephone: "(303) 209-7477",
                  email: "HI@WHOLESOL.COM"
                }
              ],
              Menu: {
                "@type": "menu",
                hasMenuSection: [
                  {
                    "@type": "MenuSection",
                    name: "Organic Juices",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Breakfast",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Acai Bowls",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Coffee",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Latte",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Vegan",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Gluten Free",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Organic Food",
                    url: "https://wholesol.com/ourmenu"
                  },
                  {
                    "@type": "MenuSection",
                    name: "Juices & Smoothies",
                    url: "https://wholesol.com/ourmenu"
                  }
                ]
              }
            })}
          </script>
        </Helmet>
        <div className="message-banner">
          <p>It is with a heavy heart that I write to you about Whole Sol's complete closure, occurring next Friday, 1/19. What has been a completely transformative journey must come to an end.</p>
          <p>Due to rising food and labor costs, food supply shortages, landlords evacuating full apartment and office buildings above us, tough economic conditions, and the general nature of the restaurant industry, Whole Sol is no longer a sustainable business. We have spent the last year fighting for the growth and profits we had seen in previous years of the business, but as just a two person (one family) ownership team, the financial burden has become too large for us to bear.</p>
          <p>We have always said that our customers and employees are the best part of Whole Sol, and that has remained true until the end. Thank you to those who have provided unwavering support of our small Mom and Pop Business.</p>
          <p>Throughout our operation, I am really proud that we never compromised on our promise to provide organic smoothie bols and juices, even when the going got tough. Of course, we could have swapped for cheaper ingredients, but that didn't seem like the right thing to do to our Sol Fam, since it isn't the way we would eat at home.</p>
          <p>XOXOXO,</p>
          <p>Alexa and Phil</p>
        </div>
        <Navigation currentLocation={location.pathname} />
        <div id="page-container">{children()}</div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx